function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const [cookieName, cookieValue] = cookies[i].split("=");
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return null;
}

function createSVG() {
  const xmlns = "http://www.w3.org/2000/svg";

  // Create the SVG element
  const svg = document.createElementNS(xmlns, "svg");
  svg.setAttribute("xmlns", xmlns);
  svg.setAttribute("viewBox", "0 0 640 480");
  svg.setAttribute("width", "32");
  svg.setAttribute("height", "24");

  // Create the <g> element
  const g = document.createElementNS(xmlns, "g");
  g.setAttribute("fill-rule", "evenodd");
  g.setAttribute("stroke-width", "1pt");
  g.setAttribute("transform", "scale(.64143 .96773)");

  // Create the first <rect> element (green background)
  const rect1 = document.createElementNS(xmlns, "rect");
  rect1.setAttribute("width", "1063");
  rect1.setAttribute("height", "708.7");
  rect1.setAttribute("fill", "#006a44");
  rect1.setAttribute("rx", "0");
  rect1.setAttribute("ry", "0");
  rect1.setAttribute("transform", "scale(.93865 .69686)");

  // Create the second <rect> element (red stripe)
  const rect2 = document.createElementNS(xmlns, "rect");
  rect2.setAttribute("width", "1063");
  rect2.setAttribute("height", "236.2");
  rect2.setAttribute("y", "475.6");
  rect2.setAttribute("fill", "#c1272d");
  rect2.setAttribute("rx", "0");
  rect2.setAttribute("ry", "0");
  rect2.setAttribute("transform", "scale(.93865 .69686)");

  // Create the <path> element (yellow stripe)
  const path = document.createElementNS(xmlns, "path");
  path.setAttribute("fill", "#fdb913");
  path.setAttribute("d", "M0 0h997.8v164.6H0z");

  // Append elements to form the SVG structure
  g.appendChild(rect1);
  g.appendChild(rect2);
  g.appendChild(path);
  svg.appendChild(g);

  // Return the created SVG element
  return svg;
}

function checkCountry() {
  const xhr = new XMLHttpRequest();
  const apiURL = "https://ipapi.co/json/";

  xhr.open("GET", apiURL, true);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        const data = JSON.parse(xhr.responseText);
        if (data.country_code === "LT") {
          const modalCount = parseInt(getCookie("modalShownCount") || "0", 10);
          if (modalCount < 2) {
            showModalPopup();
            setCookie("modalShownCount", modalCount + 1, 1); // Increment and save for 1 day
          }
        }
      } else {
        console.error("Error fetching location:", xhr.statusText);
      }
    }
  };
  xhr.onerror = function () {
    console.error("Request error");
  };
  xhr.send();
}

function showModalPopup() {
  const modal = document.createElement("div");
  modal.style.position = "fixed";
  modal.style.top = "0";
  modal.style.left = "0";
  modal.style.width = "100%";
  modal.style.height = "100%";
  modal.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
  modal.style.display = "flex";
  modal.style.justifyContent = "center";
  modal.style.alignItems = "center";
  modal.style.zIndex = "1000";

  const modalContent = document.createElement("div");
  modalContent.style.backgroundColor = "var(--secondary-background)";
  modalContent.style.padding = "15px 25px";
  modalContent.style.borderRadius = "3px";
  modalContent.style.maxWidth = "30vw";
  modalContent.style.marginLeft = "12px";
  modalContent.style.marginRight = "12px";
  modalContent.style.boxShadow = "0 1px 5px 2px #0000001a";
  modalContent.style.textAlign = "center";

  function adjustModalWidth() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 480) {
      modalContent.style.maxWidth = "100vw";
    } else if (screenWidth <= 1024) {
      modalContent.style.maxWidth = "60vw";
    } else {
      modalContent.style.maxWidth = "30vw";
    }
  }

  adjustModalWidth();
  window.addEventListener("resize", adjustModalWidth);

  const header = document.createElement("h1");
  header.textContent = "Manome, kad jūsų buvimo vieta yra";
  header.className = "heading h1";
  header.style.textAlign = "left";
  modalContent.appendChild(header);

  const flexDiv = document.createElement("div");
  flexDiv.style.display = "flex";
  flexDiv.style.gap = "12px";

  const svgElement = createSVG();
  flexDiv.appendChild(svgElement);

  const infoDiv = document.createElement("div");
  infoDiv.style.display = "flex";
  infoDiv.style.flexDirection = "column";
  infoDiv.style.alignItems = "flex-start";

  const countryName = document.createElement("strong");
  countryName.textContent = "Lithuania";
  countryName.style.fontSize = "1.2rem";
  countryName.style.lineHeight = "1";
  infoDiv.appendChild(countryName);

  const languageContainer = document.createElement("div");
  languageContainer.style.display = "flex";
  languageContainer.style.gap = "4px";
  infoDiv.appendChild(languageContainer);

  const languageLabel = document.createElement("span");
  languageLabel.textContent = "Kalba:";
  languageContainer.appendChild(languageLabel);

  const language = document.createTextNode("Lietuvių");
  languageContainer.appendChild(language);

  flexDiv.appendChild(infoDiv);
  modalContent.appendChild(flexDiv);

  const yesButton = document.createElement("button");
  yesButton.onclick = () => (window.location.href = "https://militar.lt");
  yesButton.className = "button button--primary button--full";
  yesButton.textContent = "Taip";
  yesButton.style.marginTop = "10px";
  modalContent.appendChild(yesButton);

  const noButton = document.createElement("button");
  noButton.textContent = "Ne";
  noButton.className = "button button--primary button--full";
  noButton.style.marginTop = "10px";
  noButton.onclick = () => {
    clearTimeout(redirectTimer);
    document.body.removeChild(modal);
  };
  modalContent.appendChild(noButton);

  let countdown = 10;
  const modalMessage = document.createElement("span");
  modalMessage.textContent = `Ar norėtumėte matyti pagal vietovę pritaikytą svetainės versiją? Jei nenuspausite mygtuko „Ne“, būsite automatiškai nukreipti po ${countdown} sekundžių.`;
  modalMessage.style.display = "block";
  modalMessage.style.textAlign = "left";
  modalMessage.style.marginTop = "12px";
  modalContent.appendChild(modalMessage);

  const redirectTimer = setInterval(() => {
    countdown--;
    modalMessage.textContent = `Ar norėtumėte matyti pagal vietovę pritaikytą svetainės versiją? Jei nenuspausite mygtuko „Ne“, būsite automatiškai nukreipti po ${countdown} sekundžių.`;

    if (countdown <= 0) {
      clearInterval(redirectTimer);
      window.location.href = "https://militar.lt";
    }
  }, 1000);

  modal.appendChild(modalContent);
  document.body.appendChild(modal);
}

// Call the function once the window is fully loaded
window.addEventListener("load", checkCountry);
